import { DataSource, HorizontalSpacer, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierInsControl extends Layout {
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    layoutAAEquipmentTypeMappingsPanel: Layout;
    layoutAssureAdvantageOnboardingPanel: Layout;
    layoutAssureAdvantageServerPanel: Layout;
    layoutCarrierWatchFtpServerPanel: Layout;
    layoutCarrierWatchOnboarding: Layout;
    layoutCarrierWatchServerPanel: Layout;
    layoutHwEquipmentTypeMappings: Layout;
    layoutRmisFtpServerPanel: Layout;
    layoutRmisOnboardingPanel: Layout;
    layoutRmisServerPanel: Layout;
    layoutSaferWatchServerPanel: Layout;
    panelAssureAdvantage: Panel;
    panelCarrierWatch: Panel;
    panelHighway: Panel;
    panelRmis: Panel;
    panelSaferWatch: Panel;
    sourceCarrierInsControl: DataSource;
    sourceInterfaceCodes: DataSource;
    switchAddOrderHistComment: Switch;
    switchExcludeContacts: Switch;
    switchExcludeEquipmentTypes: Switch;
    switchExcludePnnLanes: Switch;
    switchHwActive: Switch;
    switchHwAutoApproveCarriers: Switch;
    switchHwEnableAdvances: Switch;
    switchHwSendLoadData: Switch;
    switchHwShowObservedLanes: Switch;
    switchIncludeInactiveCarriers: Switch;
    switchSendCarriers: Switch;
    switchSetCarrierStatus: Switch;
    textbox1: Textbox;
    textboxContactNoResponseAction: Textbox;
    textboxContactUnknownAction: Textbox;
    textboxContactUnverifyAction: Textbox;
    textboxContactVerificationPref: Textbox;
    textboxHighwayApiKey: Textbox;
    textboxHwPacketWebsiteUrl: Textbox;
    textboxHwServer: Textbox;
    textboxLastSyncDate: Textbox;
    textboxLatestLoadDataSync: Textbox;
    textboxSendLoadDataFrequency: Textbox;
}
